import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel
} from "@mui/material";
import { useAuth } from "../Main/Components/Context/authContext";
import {
  addDoc,
  collection,
  getDocs,
  updateDoc,
  doc,
  query,
  orderBy
} from "firebase/firestore";
import { db2 } from "../Main/Components/firebase";
import { Select, MenuItem } from "@mui/material";
import moment from "moment-timezone";
import "./Attendance.style.css";

const Attendance = () => {
  const { user } = useAuth();
  const [nombre, setNombre] = useState("");
  const [reservas, setReservas] = useState([]);
  const [comentarios, setComentarios] = useState({});
  const [fechaFiltro, setFechaFiltro] = useState("");
  const [fechaFiltroFake, setFechaFiltroFake] = useState("");
  const [fechaFiltro2, setFechaFiltro2] = useState("");
  const [fechaFiltroFake2, setFechaFiltroFake2] = useState("");
  const [profesorFiltro, setProfesorFiltro] = useState("Luis");

  // Función para obtener los datos de la colección 'attendance' ordenados por timestamp
  const getReservas = async () => {
    try {
      // Crear la consulta ordenada por timestamp de manera ascendente
      const reservasQuery = query(
        collection(db2, "attendance"),
        orderBy("timestamp", "asc")
      );
      const querySnapshot = await getDocs(reservasQuery);
      const reservasData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      console.log(reservasData);

      setReservas(reservasData);

      // Crear un objeto de comentarios vacío para cada reserva
      const comentariosInicial = {};
      reservasData.forEach((reserva) => {
        comentariosInicial[reserva.id] = reserva.comentario || ""; // Si no hay comentario, establecer como cadena vacía
      });
      setComentarios(comentariosInicial);
    } catch (error) {
      console.error("Error getting documents: ", error);
    }
  };

  // Función para agregar una nueva reserva
  const addReserva = async () => {
    const nowColombia = moment().tz("America/Bogota");
    const nuevaReserva = {
      fecha: fechaFiltro2 ? fechaFiltro2 : nowColombia.format("DD/MM/YYYY"), // Formatear la fecha actual de Colombia
      hora: nowColombia.format("HH:mm"), // Formatear la hora actual de Colombia
      nombre: nombre,
      profesor: profesorFiltro,
      timestamp: nowColombia.toDate() // Usar el timestamp actual de Colombia para ordenación
    };

    try {
      const docRef = await addDoc(collection(db2, "attendance"), nuevaReserva);
      getReservas(); // Actualizar los datos después de agregar una nueva reserva
      setNombre(""); // Limpiar el nombre después de agregar la reserva

      // Crear un comentario vacío asociado a la nueva reserva
      setComentarios((prevState) => ({
        ...prevState,
        [docRef.id]: ""
      }));
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  };

  // Función para manejar cambios en los comentarios
  const handleComentarioChange = (id, comentario) => {
    setComentarios((prevState) => ({
      ...prevState,
      [id]: comentario
    }));
  };

  // Función para guardar los comentarios en la base de datos
  const saveComentarios = async (id) => {
    try {
      await updateDoc(doc(db2, "attendance", id), {
        comentario: comentarios[id]
      });
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  // Obtener las reservas al cargar el componente
  useEffect(() => {
    getReservas();
    console.log(reservasFiltradas, "reservas filtradas");
    console.log("fecha filtro", fechaFiltro);
  }, [fechaFiltro]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      addReserva();
    }
  };

  // Filtrar reservas por fecha y profesor
  const reservasFiltradas = reservas
    .filter((reserva) => {
      // Si no se ha seleccionado ninguna fecha, mostrar todas las reservas
      if (!fechaFiltro) return true;
      // Si la fecha de la reserva es igual a la fecha seleccionada, mostrarla
      return reserva.fecha === fechaFiltro;
    })
    .filter((reserva) => {
      // Filtrar por profesor
      return reserva.profesor === profesorFiltro;
    });

  const reverseDateFormat = (dateString) => {
    setFechaFiltroFake(dateString);
    const [year, month, day] = dateString.split("-");
    setFechaFiltro(`${day}/${month}/${year}`);
  };

  const reverseDateFormat2 = (dateString) => {
    setFechaFiltroFake2(dateString);
    const [year, month, day] = dateString.split("-");
    setFechaFiltro2(`${day}/${month}/${year}`);
  };

  return (
    <div>
      <h1>Reservas</h1>
      <div className="Attendance__div--filters">
        <FormControl variant="outlined" style={{ marginRight: "1em" }}>
          <label htmlFor="fecha-filtro">Filtrar por Fecha</label>
          <input
            type="date"
            id="fecha-filtro"
            value={fechaFiltroFake}
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "8px",
              width: "220px",
              height: "60px",
              boxSizing: "border-box",
              fontSize: "20px"
            }}
            onChange={(e) => reverseDateFormat(e.target.value)}
          />
        </FormControl>
        <FormControl variant="outlined" style={{ marginRight: "1em" }}>
          <InputLabel id="profesor-filtro-label">
            Filtrar por Profesor
          </InputLabel>
          <Select
            labelId="profesor-filtro-label"
            value={profesorFiltro}
            onChange={(e) => setProfesorFiltro(e.target.value)}
            label="Filtrar por Profesor"
            sx={{ width: "220px" }}
          >
            <MenuItem value="Luis">Luis</MenuItem>
            <MenuItem value="Ozzie">Ozzie</MenuItem>
            <MenuItem value="Daniela">Daniela</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Ingrese el nombre"
          variant="outlined"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <div style={{display:'flex',flexDirection:'column'}}>
          <label htmlFor="fecha-filtro">Elegir fecha de reserva</label>
          <input
            type="date"
            value={fechaFiltroFake2}
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "8px",
              width: "220px",
              height: "60px",
              boxSizing: "border-box",
              fontSize: "20px"
            }}
            onChange={(e) => reverseDateFormat2(e.target.value)}
          />
        </div>
        <Button
          variant="contained"
          sx={{ bgcolor: "#333333", ":hover": { background: "#333333" } }}
          onClick={addReserva}
        >
          Guardar Reserva
        </Button>
      </div>
      <TableContainer component={Paper} style={{ marginTop: "1em" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Fecha</TableCell>
              <TableCell>Hora</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Comentario</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reservasFiltradas.map((reserva) => (
              <TableRow key={reserva.id}>
                <TableCell>{reserva.fecha}</TableCell>
                <TableCell>{reserva.hora}</TableCell>
                <TableCell>{reserva.nombre}</TableCell>
                <TableCell>
                  {user && (
                    <TextField
                      variant="outlined"
                      value={comentarios[reserva.id]}
                      onChange={(e) =>
                        handleComentarioChange(reserva.id, e.target.value)
                      }
                      onBlur={() => saveComentarios(reserva.id)}
                    />
                  )}
                  {!user && (
                    <TextField
                      variant="outlined"
                      value={comentarios[reserva.id]}
                      disabled
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Attendance;
